import { Grid, Typography, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppWrapperContainer from "../../components/AppWrapperContainer";
import careerBgMobile from "../../public/assets/images/home/more/career/careerBgMobile.webp";
import careerCompleteBgForLarge from "../../public/assets/images/home/more/career/careerbglarge.webp";
import careerCompleteBgForXtraLarge from "../../public/assets/images/home/more/career/careerBgForXtraLarge.webp";
import careerCompleteBg from "../../public/assets/images/home/more/career/careerCompleteBg.webp";
import ESOPS from "../../public/assets/images/home/more/career/ESOPS.webp";
import bestGadget from "../../public/assets/images/home/more/career/bestGadget.webp";
import teamOutings from "../../public/assets/images/home/more/career/teamOutings.webp";
import GromoGallery from "../../components/career/GromoGallery";
import GromoGalleryMobile from "../../components/career/GromoGalleryMobile";
import Image from "next/image";
import AppFooter from "../../components/AppFooter";
import Stories from "../../components/career/Stories";
import CurrentOpening from "../../components/career/CurrentOpening";
import Link from "next/link";
import { loadJobsOpenings } from "../../lib/loadServerData";
import Seo from "../../components/Seo";

function serializeJobRow(job: any) {
  const row = typeof job?.toObject === "function" ? job.toObject() : job;
  return {
    department: job?.get?.("Department") ?? row?.Department ?? null,
    position: job?.get?.("Position") ?? row?.Position ?? null,
    experience: job?.get?.("Experience") ?? row?.Experience ?? null,
    link: job?.get?.("Link") ?? row?.Link ?? null,
  };
}

export async function getServerSideProps() {
  try {
    const data: any = await loadJobsOpenings();
    const jobs = (data ?? []).map(serializeJobRow);
    return { props: { jobs } };
  } catch (error) {
    console.error("[careers] Failed to load job openings:", error);
    return { props: { jobs: [] } };
  }
}

function Careers(props: any) {
  const [floatingBtn, setFloatingBtn] = useState(true);
  const siteUrl =
    process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/+$/, "") || "https://gromo.in";

  const jobPostingsJsonLd =
    Array.isArray(props?.jobs) && props.jobs.length
      ? {
          "@context": "https://schema.org",
          "@graph": props.jobs
            .filter((job: any) => Boolean(job?.position))
            .map((job: any) => ({
              "@type": "JobPosting",
              title: String(job.position),
              description: [job.department, job.experience]
                .filter(Boolean)
                .map(String)
                .join(" • "),
              hiringOrganization: {
                "@id": `${siteUrl}/#organization`,
              },
              jobLocation: {
                "@type": "Place",
                address: {
                  "@type": "PostalAddress",
                  addressLocality: "Gurugram",
                  addressRegion: "Haryana",
                  addressCountry: "IN",
                },
              },
              applicantLocationRequirements: {
                "@type": "Country",
                name: "IN",
              },
              url: job.link ? String(job.link) : `${siteUrl}/careers`,
            })),
        }
      : null;

  useEffect(() => {
    globalThis.window?.addEventListener("scroll", handleScroll, {
      passive: true,
    });
  }, []);
  const handleScroll = (event: any) => {
    if (globalThis.window?.pageYOffset > 2500) {
      setFloatingBtn(false);
    } else {
      setFloatingBtn(true);
    }
  };

  return (
    <>
      <Seo
        title="Careers at GroMo | Join India’s Fastest Growing Fintech"
        description="We're Hiring! Check the career page and Join GroMo today. Discover the latest job openings and apply for the profile that suits you best."
        keywords="Join GroMo today"
        openGraph={{
          title: "Careers at GroMo | Join India’s Fastest Growing Fintech",
          description:
            "We're Hiring! Check the career page and Join GroMo today. Discover the latest job openings and apply for the profile that suits you best.",
          type: "website",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        twitter={{
          title: "Careers at GroMo | Join India's Fastest Growing Fintech Platform",
          description:
            "We're Hiring! Check the career page and Join GroMo today. Discover the latest job openings and apply for the profile that suits you best.",
          url: "https://gromo.in/careers",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        jsonLd={jobPostingsJsonLd ? [jobPostingsJsonLd] : undefined}
      />
      <AppWrapperContainer nav navBgColor="#002561">
        <Grid
          container
          sx={{
            minHeight: { xs: "95vh", md: "1000px", lg: "551px" },
            justifyContent: "space-evenly",
            color: "black",
            padding: { xs: "4%", md: "4%", lg: "3% 11%" },
            background: {
              xs: `url("${careerBgMobile.src}")`,
              md: `url("${careerCompleteBg.src}")`,
              xl: `url("${careerCompleteBgForXtraLarge.src}")`,
            },

            backgroundSize: { xs: "cover", md: "cover", xl: "contain" },
            backgroundRepeat: {
              xs: "no-repeat",
              md: "no-repeat",
              xl: "no-repeat",
            },
            backgroundPosition: { xs: "bottom", md: "bottom", xl: "" },
          }}
        >
          <Grid
            sx={{
              minHeight: "200px",
              color: "white",
              zIndex: "1",
            }}
          >
            <Typography
              component="h1"
              textAlign="center"
              fontWeight="600"
              margin="15px 0"
              sx={{
                fontSize: { xs: "28px", md: "40px" },
                lineHeight: { xs: "36px", md: "56px" },
              }}
            >
              Build Fast. All day. Every Day.
            </Typography>

            {[
              `We build innovative products & solutions that help elevate`,
              `the lives of millions of users across India`,
            ].map((item, i) => {
              return (
                <Typography
            
                  textAlign="center"
                  margin="5px 0"
                  fontWeight="400"
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    lineHeight: { xs: "24px", md: "32px" },
                  }}
                  key={i}
                >
                  {item}
                </Typography>
              );
            })}
            <Grid
              sx={{
                position: {
                  xs: "absolute",
                  lg: "static",
                },
                bottom: 0,
                left: 0,
                right: 0,
                top: "272px",
              }}
            >
              <Link
                href="#currentOpening"
                style={{ textDecoration: "none", color: "white" }}
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#08AC17",
                    padding: "12px 24px",
                    display: {
                      xs: floatingBtn ? "block" : "none",
                      md: "block",
                    },
                    margin: "15px auto",
                    color: "white",
                    zIndex: 6,
                    "&:hover": {
                      backgroundColor: "#08AC17",
                    },
                    width: { xs: "320px", md: "fit-content" },
                  }}
                >
                  Come, join us!
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>

        <Grid sx={{ display: { xs: "block", md: "none" } }}>
          <GromoGalleryMobile />
        </Grid>
        <Grid
          sx={{
            display: { xs: "none", md: "block" },
            maxWidth: "1440px",
            margin: "auto",
          }}
        >
          <GromoGallery />
        </Grid>

        <Stories />

        <Grid
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            padding: "4%",
            margin: "auto",
            maxWidth: "1440px",
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: "700",
              fontSize: { xs: "28px", md: "32px" },
              lineHeight: { xs: "36px", md: "40px" },
              width: { xs: "100%", md: "75%" },
              margin: { xs: "8px auto", md: "auto" },
            }}
          >
            Get ready for a 100% awesome GroMo experience
          </Typography>
          <Typography
            sx={{
              fontWeight: { xs: "400", md: "500" },
              fontSize: { xs: "16px", md: "18px" },
              lineHeight: { xs: "24px", md: "24px" },
              width: { xs: "100%", md: "75%" },
              margin: { xs: "8px auto", md: "auto" },
              color: "#393F50",
            }}
          >
            We will take care that you get the best gadgets, best incentives,
            best work settings, best breaks and everything in between - promise!
          </Typography>
        </Grid>
        <Grid
          sx={{
            display: "grid",
            // placeContent: "left",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            width: { xs: "100%", md: "60%" },
            margin: "auto",
            padding: "2% 4%",
            justifyItems: "center",
          }}
        >
          {[
            {
              CardTitle: "ESOPS",
              Image: ESOPS,
              content:
                "Our wins are your wins. Get ESOP and performance based incentives.",
            },
            {
              CardTitle: "Best Gadgets",
              Image: bestGadget,
              content:
                "To win a war, a soldier needs to have arms and ammunition. Get top-notch hardware to fuel your dreams.",
            },
            {
              CardTitle: "Team Outings",
              Image: teamOutings,
              content:
                "It’s always a good idea to party. Join us for regular team parties and outings.",
            },
          ].map((item, i) => {
            return (
              <Grid
                key={item.CardTitle}
                sx={{
                  width: { xs: "100%", md: "70%" },
                  margin: { xs: "20px auto", md: "10px auto" },
                  minHeight: { xs: "fit-content", md: "300px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Grid sx={{ margin: "8px 0" }}>
                  <Image
                    src={item.Image}
                    alt={item.CardTitle}
                    style={{
                      height: "120px",
                      objectFit: "contain",
                      width: "fit-content",
                    }}
                    width={100}
                    height={100}
                    loading="lazy"
                  />
                </Grid>
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "24px",
                    lineHeight: "36px",
                    margin: { xs: "8px 0" },
                  }}
                  key={i}
                >
                  {item.CardTitle}
                </Typography>

                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: { xs: "16px", md: "16px" },
                    lineHeight: { xs: "24px", md: "24px" },
                    color: "#6C717F",
                  }}
                >
                  {item.content}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
        <Grid id="currentOpening" sx={{ backgroundColor: "#F4F7FF" }}>
          <CurrentOpening jobs={props.jobs} />
        </Grid>
      </AppWrapperContainer>

      <AppFooter />
    </>
  );
}

export default Careers;
